export const AlarmUtility = (): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="#363BC4"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14.22 17.6c0 1.325-.994 2.4-2.22 2.4s-2.222-1.075-2.222-2.4M13.33 7.39c.322-.36.52-.85.52-1.39 0-1.105-.828-2-1.85-2s-1.852.895-1.852 2c0 .54.199 1.03.521 1.39m5.773 3.97c0-1.103-.468-2.161-1.3-2.942A4.6 4.6 0 0 0 12 7.2a4.6 4.6 0 0 0-3.142 1.218c-.833.78-1.301 1.839-1.301 2.942 0 1.825-.42 3.16-.942 4.116-.596 1.088-.894 1.633-.882 1.763.013.149.038.196.15.284.097.077.588.077 1.569.077h9.095c.981 0 1.472 0 1.57-.077.111-.088.136-.135.15-.284.011-.13-.287-.675-.883-1.763-.523-.956-.942-2.29-.942-4.116"
    />
  </svg>
);
